blue.ready('quickLinks', '.quick-links', ql => {
  const links = [...ql.querySelectorAll('a.quick-link')];
  const count = links.length;
  const max = 4;
  const left = ql.querySelector('.quick-links__left');
  const right = ql.querySelector('.quick-links__right');
  const container = ql.querySelector('.quick-links__inner');
  let currentPosition = 0;

  const setPosition = function(selectedPosition) {
    return function curried_set(e) {
      if (e) {
        e.preventDefault();
      }

      const itemWidth = links[0].offsetWidth;
      const width = (selectedPosition * itemWidth).toString();
      container.style.left = width + 'px';

      currentPosition = selectedPosition;

      if (currentPosition < 0 && count > max && left) {
        left.classList.remove('disabled');
      }
      else if (left) {
        left.classList.add('disabled');
      }

      if (currentPosition > (max - count) && count > max && right) {
        right.classList.remove('disabled');
      } 
      else if (right) {
        right.classList.add('disabled');
      }
    }
  }

  if (count <= max || count <= 0) {
    if (left) {
      left.remove();
    }

    if (right) {
      right.remove();
    }
  } else {
    window.addEventListener('resize', function() { setPosition(currentPosition)(); });
    window.addEventListener('orientationchange', function() { setPosition(currentPosition)(); });

    right.addEventListener('click', function(){ 
      if (!right.classList.contains('disabled')) {
        setPosition(currentPosition - 1)();
      }

      return false;
    });
    
    left.addEventListener('click', function(){
      if (!left.classList.contains('disabled')) {
        setPosition(currentPosition + 1)();
      }

      return false;
    });
    
    setPosition(0)();
  }
});